import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

// This page now redirects to OTP login - email/password auth has been removed
const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // Redirect authenticated users to their intended destination
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    } else {
      // Redirect to OTP login page, preserving the redirect state
      navigate('/otp-login', { 
        replace: true, 
        state: location.state 
      });
    }
  }, [isAuthenticated, navigate, location.state]);

  return null;
};

export default LoginPage;
